// when we don't know, use these rules
export const defaultRules = {
  minLength: 8,
  classCount: 3,
};

export const MIN_PASSWORD_METER_LENGTH = 9;
